module.exports = __webpack_public_path__ + "static/media/preparing-annual-accounts.436532b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/preparing-annual-accounts.jpg
// module id = 279
// module chunks = 0